<template>
  <div class="addressComponent">
    <input
      type="hidden"
      v-model="propNo"
      v-bind:name="fieldName + 'PropertyNo'"
      v-bind:id="fieldName + 'PropertyNo'"
    >
    <input
      type="hidden"
      v-model="ward"
      v-bind:name="fieldName + 'Ward'"
      v-bind:id="fieldName + 'Ward'"
    >
    <div class="control has-icons-right">
      <!-- the input field -->
      <input
        type="text"
        v-bind:name="fieldName"
        v-bind:id="fieldName"
        class="input"
        v-bind:placeholder="placeholder"
        autocomplete="off"
        v-model="query"
        @keydown.down="down"
        @keydown.up="up"
        @keydown.enter="hit"
        @keydown.esc="resetInput"
        @blur="resetInput"
        @input="autoComplete"
      >

      <!-- keydown.esc="reset" -->
      <span class="icon is-small is-right">
        <!-- optional indicators -->
        <i v-if="!isDirty" class="fa fa-search"></i>
        <i v-else-if="propNo > 0" class="fa fa-check" style="color: green;"></i>
        <i v-else-if="loading" class="fa fa-spinner fa-spin"></i>
        <i v-else-if="!hasItems && query.length >= minChars" class="fa fa-question"></i>
      </span>
    </div>

    <!-- the list -->
    <ul class="addressResults" v-show="hasItems">
      <!-- for vue@1.0 use: ($item, item) -->
      <li
        v-for="(item, $item) in items"
        :key="item.id"
        :class="activeClass($item)"
        @mousedown="hit"
        @mousemove="setActive($item)"
      >
        <span v-text="item.Property_Text_B"></span>
        <span v-if="item.Property_Name">[ {{ item.Property_Name }} ]</span>
      </li>
    </ul>
  </div>
</template>

<script>
import VueTypeahead from "vue-typeahead";

var searchTimer;

export default {
  extends: VueTypeahead,

  props: {
    source: {
      type: [String, Array],
      required: true
    },
    placeholder: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      query: "",
      isHit: false,
      propNo: "",
      ward: "",
      error: "",

      // The source url
      // (required)
      // src: 'https://typeahead-js-twitter-api-proxy.herokuapp.com/demo/search',
      // src: 'http://laravel-5.5-online2.dev/api/address/test',
      src: this.source,

      // The data that would be sent by request
      // (optional)
      data: {},

      // Limit the number of items which is shown at the list
      // (optional)
      limit: 10,

      // The minimum character length needed before triggering
      // (optional)
      minChars: 5,

      // Highlight the first item in the list
      // (optional)
      selectFirst: true

      // Override the default value (`q`) of query parameter name
      // Use a falsy value for RESTful query
      // (optional)
      //queryParamName: 'search'
    };
  },

  computed: {
    // removed 16 april as not used i believe
    // fullName: function () {
    //   return this.firstname + ' ' + this.lastname
    // }
  },

  methods: {
    // The callback function which is triggered when the user hits on an item
    // (required)
    onHit(item) {
      this.isHit = true;
      if (item.Property_No == 0) {
        this.$emit("addressTyping", this.query);
        this.query = "";
      } else {
        this.query = item.Property_Text_B;
      }
      this.$emit("address", item.Property_Text_B);
      this.$emit("addressPropertyNo", item.Property_No);
      this.$emit("addressWard", item.Ward);

      this.propNo = item.Property_No;
      this.ward = item.Ward;
      this.loading = false;
      this.items = [];
    },

    // The callback function which is triggered when the response data are received
    // (optional)
    prepareResponseData(data) {
      return data;
    },

    autoComplete: function() {
      this.propNo = "";
      this.$emit("addressTyping", this.query);
      this.$emit("addressPropertyNo", this.propNo);

      this.error = `             
              <div
                class='notification'
                v-if='addressPropertyNo==0 && addressTyping.length>0 && $v.addressPropertyNo.$error || this.addressNotFound == true"
                style="border-radius: 6px; margin-top: .5em;"
              >
                <h5 class="title is-5" style="margin-bottom: .2em;">
                  <strong>Need help with the address finder?</strong>
                </h5>
                <small>
                  1. Start typing the
                  <strong>house number</strong> and
                  <strong>street name</strong> and then
                  <u>wait for the list to load</u>.
                  <div style="padding-left: 2em;">
                    examples:
                    <br>
                    <strong>1/10 Main St</strong>
                    <br>
                    <strong>6 Main Ave</strong>
                  </div>2. Then select full address from the list.
                </small>
                <template>
                  <hr>
                  <input type="checkbox" id="addressNotFound" v-model="addressNotFound">
                  <label for="addressNotFound">
                    <small>My address is not found in the dropdown list.</small>
                  </label>
                </template>
              </div>`;

      this.$emit("error", this.error);

      if (this.query.length >= this.minChars) {
        clearTimeout(searchTimer);
        searchTimer = setTimeout(this.update, 300);
      }
    },

    resetInput: function() {
      if (!this.isHit) {
        this.reset;
      }
      this.isHit = false;
      this.items = [];
      this.loading = false;
    },

    clearQuery: function() {
      this.query = "";
      alert("clear");
    }
  }
};
</script>

<style>
.addressComponent .addressResults {
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-shadow: 1px 1px 5px #aaaaaa;
}
.addressComponent li {
  padding: 0.25em;
  border-bottom: 1px solid #eee;
}
.addressComponent li.active {
  background: #222;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/address/Typeahead-CouncilAddress.vue